<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">司机端版本管理</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" size="small">
        <el-form-item label>
          <el-input
            v-model="filterForm.versionNum"
            clearable
            placeholder="请输入版本号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handlerSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-wrench"
            label="提交新应用"
            perms="-1"
            type="primary"
            @click="showDialog = true"
          />
        </el-form-item>
      </el-form>
      <el-table :data="versionList" stripe size="mini" style="width: 100%">
        <el-table-column
          label="序号"
          width="50"
          align="center"
          fixed
          type="index"
        ></el-table-column>

        <el-table-column
          label="司机端版本号"
          align="center"
          width="120"
          prop="versionNum"
        ></el-table-column>
        <el-table-column
          label="司机端下载地址"
          prop="upgradeFileUrl"
          align="center"
        ></el-table-column>
        <el-table-column
          label="上传时间"
          prop="createTime"
          align="center"
          width="240"
        ></el-table-column>
        <el-table-column
          label="操作人"
          prop="createUser"
          align="center"
          width="120"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right;padding:10px"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="showDialog"
      title="提交新应用"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="40%"
    >
      <el-form :model="newappForm" label-width="100px" size="mini" :rules="rulesForm" ref="refForm">
        <el-form-item label="版本号：" prop="version">
          <div class="flex">
            <el-input class="min-input" v-model.number="version.first" maxlength="1"  />.
            <el-input class="min-input" v-model.number="version.second" maxlength="1" />.
            <el-input class="min-input" v-model.number="version.third" maxlength="1" />
            <span class="tips">(需大于已上传版本号)</span>
          </div>
        </el-form-item>
        <el-form-item label="提交新应用">
          <el-upload
            class="upload-demo"
            :file-list="fileList"
            :limit="1"
            :action="actionUrl"
            :data="extraData"
            :on-exceed="handleExceed"
            :on-success="successUpload"
            :on-remove="handleRemove"
            :before-upload="beforeLogoUpload"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
          <span>{{uploadStatus}}</span>
        </el-form-item>
        <el-form-item label="下载地址" prop="upgradeFileUrl" ref="upgradeFileUrl">
          <el-input v-model="newappForm.upgradeFileUrl"  style="width:70%" disabled></el-input>
        </el-form-item>
        <el-form-item label="升级说明：">
          <Tinymce ref="editor" v-model="newappForm.remark" v-if="showDialog"  :height="200" @successCBK="receiveImgUrl" @blur="handleInput" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click=" showDialog= false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton.vue";
import Tinymce from '@/components/Tinymce'
import global from "@/utils/global";
export default {
  data() {
    return {
      filterForm: {
        versionNum: "",
      },
      actionUrl: global.baseUrl + "/admin/version/file/upload",
      pageNo: 1,
      pageSize: 10,
      totalSize: 10,
      versionList: [],
      showDialog: false,
      version:{
        first: null,
      second: "",
      third: "",
      },
      postForm:{

      },
      newappForm: {
        upgradeFileUrl:''
      },
      uploadStatus:'',
      fileList: [],
      extraData: {
        loginStaffId: localStorage.getItem("loginStaffId"),
        token: localStorage.getItem("token"),
        systemType: "ejy",
      },
      txtDesc:{},
      rulesForm:{
        version:[{
          required:true ,  validator:this.checkVersion() ,trigger:'change'
        }],
        upgradeFileUrl:[{
          required: true, message: '请上传apk', trigger: 'blur'
        }],
      }
    };
  },
  components: {
    KtButton,
    Tinymce
  },
  created() {
    this.getVersionList();
  },

  methods: {
    handlerSearch() {
      this.getVersionList();
    },
    getVersionList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      if (this.filterForm.versionNum) {
        params["searchFieldList[0].fieldName"] = "versionNum";
        params["searchFieldList[0].singleValue"] = this.filterForm.versionNum;
      }
      this.$api.appManage
        .mGetVersionList({
          ...params,
        })
        .then((res) => {
          this.versionList = res.data.dtoList;
          this.totalSize = res.data.totalSize;
        })
        .catch((err) => {});
    },
    messageOnly(){
      
      
    },
    sumLetter(val){
        var re1 = new RegExp("<.+?>","g");
        var txt = val.replace(re1,'');
        txt = txt.replace(/\n/g,'');
        txt = txt.replace(/&nbsp;/g,' ');
        var num=txt.length;
        return {txt:txt,num:num}
    },
    handleInput(val){
      // obj:{txt: '你好地方', num: 4}
      this.txtDesc = this.sumLetter(val)
      if(this.txtDesc.num>50){
        let dom= document.getElementsByClassName('el-message')[0]
        if(dom == undefined){
          this.$message({
          type:'error',
          message:`最多输入50个字,当前字数为${this.txtDesc.num}`,
          offset:200
        })
        return
        }
        
      }
    },
    refreshPageRequest(val) {
      this.pageNo = val;
      this.getVersionList();
    },
    dialogCloseCallback() {
      this.version ={
        first:'',
        second:'',
        third:''
      }
      this.$nextTick((res) => {
        this.newappForm.remark = ''
      })
      // this.newappForm = this.$options.data().newappForm;
      this.$refs.refForm.resetFields()
      this.uploadStatus =''
      this.fileList =[]
    },
    handleExceed() {
      this.$message.warning("最多上传一个安装包");
    },
    receiveImgUrl(arr){
      console.log(arr);
    },
    beforeLogoUpload(file) {
      const isApp = file.type === "application/vnd.android.package-archive";
      const isApk = file.name.includes(".apk");
      const size = file.size / 1024 / 1024;
      this.uploadStatus = '上传中...'
      if(!isApp||!isApk){
        this.$message({
          message: "仅支持上传apk格式文件",
          type: "error",
          offset: 300,
        })
        return false
      }
      if(size >200){
        this.$message({
          message: "上传的apk包不能大于200mb",
          type: "error",
          offset: 300,
        })
        return false
      }
      return true;
    },
    successUpload(res){
      
      if(res.code == '0'){
        this.$nextTick(() => {
          this.newappForm.upgradeFileUrl = res.data
          this.uploadStatus = '上传成功'
          this.$refs.upgradeFileUrl.clearValidate()
        })
      }else{
        this.message({
          message:'图片上传失败！',
          type:'error',
          offset:300
        })
        this.uploadStatus = ''
        this.newappForm.upgradeFileUrl = ''
        this.fileList =[]
      }
    },
    handleRemove(){
      this.newappForm.upgradeFileUrl = ''
      this.uploadStatus =''
    },
    isNumber(val){
      return Number.isInteger(val)
    },
    isEmpty(val){
      return val||val==0
    },
    checkVersion(){
      return (rule,value,callback) => {
        let {first , second , third} =this.version
        if(!this.isEmpty(first)||!this.isEmpty(second)||!this.isEmpty(third)){
          return callback(new Error('请输入版本号'))
        }
        if(!(this.isNumber(first)&&this.isNumber(second)&&this.isNumber(third))){
          return callback(new Error('版本号仅支持0-9的数字'))
        }
        
        return callback()
      }
    },
    submitForm(){
      // console.log(this.$refs.editor.activeEditor)
      if(this.txtDesc.num >50){
        this.$message({
          type:'error',
          message:'最多输入50个字',
          offset:200
        })
        return
      }
      this.$refs.refForm.validate(async(valid) => {
        if(valid){
          
          let {first , second , third} =this.version
          let versionNum = `${first}.${second}.${third}`
        let res= await this.$api.appManage.checkVersion({
          versionNum
        })
        // console.log(this.newappForm.remark);
        this.$api.appManage.addVersion({
          versionNum,
          upgradeFileUrl:this.newappForm.upgradeFileUrl,
          remark:this.newappForm.remark
        }).then((res) => {
          this.$message({
            type:'success',
            message:'提交成功',
            offset:300
          })
          this.showDialog = false
          this.dialogCloseCallback()
          this.getVersionList()
        })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.flex {
  display: flex;
  align-items: center;
}
.min-input {
  width: 60px;
}
.tips {
  font-size: 12px;
  color: red;
}
.upload-demo {
  display: flex;
  align-items: center;
}
::v-deep .el-upload-list__item {
  margin-top: 0 !important;
}
::v-deep .el-form-item__content{
  display: flex;
  align-items: center;
}
</style>